/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./qc-point.vue?vue&type=template&id=2cefea51&scoped=true&"
import script from "./qc-point.vue?vue&type=script&lang=js&"
export * from "./qc-point.vue?vue&type=script&lang=js&"
import style0 from "./qc-point.vue?vue&type=style&index=0&id=2cefea51&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cefea51",
  null
  
)

export default component.exports